import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoPersoStep5Bloc from "../blocs/info-perso/InfoPersoStep5Bloc";

export default function InfoPersoStep5Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
   
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Confirmez vos modalités de contact</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep5Bloc />
        </div>
          <div className="m-lg-desktop pt-xs">
            <div className="text ta-left fz-xs" style={{textAlign: 'justify'}}>
              En tant que responsable de traitement, le groupe MGP traite vos données à caractère personnel pour : 
              <br />
              - permettre votre affiliation à la mutuelle, gérer votre contrat et exécuter vos garanties. Les traitements effectués à ce titre sont fondés sur la conclusion ou l’exécution de votre contrat, la poursuite des intérêts légitimes du groupe MGP ou le respect de ses obligations légales et réglementaires. 
              <br />
              -	 la prospection commerciale par le groupe MGP, par voie téléphonique, email et / ou SMS, selon vos choix, ce traitement étant effectué sur la base de votre consentement
              <br/>
              Vos données à caractère personnel pourront être transmises aux entités du groupe MGP, à ses prestataires, aux autres organismes intervenant dans la gestion et l’exécution de votre contrat ainsi qu’aux autorités compétentes. 
              <br/>
              Vos données à caractère personnel sont conservées jusqu’à l’accomplissement des finalités de traitement ou l’expiration des délais de conservation imposés par les exigences légales ou réglementaires. La durée de conservation est donc variable et dépend de la nature des données et des finalités poursuivies par les traitements mis en place. 
              <br/>
              Vous disposez d’un droit d’accès, de rectification, de suppression et de portabilité de vos données, ainsi que du droit de définir des directives relatives au sort de vos données à caractère personnel après votre décès. Vous pouvez également vous opposer ou limiter le traitement de vos données à caractère personnel. 
              <br/>
              Le groupe MGP dispose d’un délégué à la protection des données personnelles (DPO) que vous pouvez également contacter pour toute question relative à vos données à caractère personnel ainsi que pour exercer vos droits :
              <br/>
              - soit par mail : dpo@mgp.fr ;
              <br/>
              - soit par courrier : Mutuelle MGP - Service juridique - TSA 30245 - 93736 BOBIGNY CEDEX 9 
              <br/>
              Vous pouvez par ailleurs introduire une réclamation auprès de la CNIL (Commission Nationale Informatique et Libertés). 
              <br/>
              <p className="pt-xs">
                Pour avoir plus d’informations sur les catégories de données traitées, le détail des finalités des traitements effectués sur ces données, les destinataires des données et les durées de conservation, vous veuillez vous référer à la notice d’information qui vous sera remise à la fin du parcours dans l’onglet « Autres documents contractuels ». 
              </p>
            </div>
          </div>
      </div>
  
    )

}